import { useQuery } from '@tanstack/react-query'

import ErrorNotificationKeyGenerator from './ErrorNotificationKeyGenerator'

import { getReleasedErrorNotifications } from '@/api/query'
// import { useGetCurrentUser } from '@/queries/user/useGetCurrentUser'

// NOTE: error notification 기능 비활성화 (polling 중단).
// 재활성화 시 아래 주석을 복원하고 하단 disabled stub을 제거한다.
// function useErrorNotifications() {
//   const { data: currentUser } = useGetCurrentUser()
//   const isAuthenticated = !!currentUser?.data?.response?.id
//
//   return useQuery({
//     queryKey: ErrorNotificationKeyGenerator.all(),
//     queryFn: getReleasedErrorNotifications(),
//     refetchInterval: 60 * 1000,
//     staleTime: 30 * 1000,
//     enabled: isAuthenticated,
//   })
// }

function useErrorNotifications() {
  return useQuery({
    queryKey: ErrorNotificationKeyGenerator.all(),
    queryFn: getReleasedErrorNotifications(),
    enabled: false,
  })
}

export default useErrorNotifications
